module.exports = __webpack_public_path__ + "img/form-4.ba4dffe3.svg";